/* eslint-disable react/jsx-key */

import React from 'react';
import { createIcon } from '@chakra-ui/icons';

export const FlagIconUzbekistan = createIcon({
  displayName: 'FlagIconUzbekistan',
  viewBox: '0 0 640 480',
  path: [
    <path fill="#1eb53a" d="M0 0h640v160H0z" />,
    <path fill="#fff" d="M0 160h640v160H0z" />,
    <path fill="#0099b5" d="M0 320h640v160H0z" />,
    <path fill="#ce1126" d="M0 155h640v10H0z" />,
    <path fill="#ce1126" d="M0 315h640v10H0z" />,
  ],
});
